import React from 'react';
import Header from './Header';

const LandingPage = () => {
  return (
    <div>
      <Header />

      {/* Hero Section */}
      <section style={{
        //padding: '80px 0',
        backgroundColor: '#f8f9fa'
      }}>
        <div className="container-hero">
          <div style={{
            backgroundImage: `url("/images/living-room-scandinavian-interior-design.jpg")`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '400px',
            //borderRadius: '12px',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            {/* Optional overlay for better text readability */}
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.1)',
              borderRadius: '12px'
            }}></div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section style={{ padding: '80px 0', backgroundColor: 'white' }}>
        <div className="container text-center">
          <h2 style={{
            fontSize: '36px',
            marginBottom: '20px',
            color: '#333'
          }}>
            Buy from experts
          </h2>
          <p style={{
            fontSize: '18px',
            color: '#666',
            marginBottom: '60px',
            maxWidth: '600px',
            margin: '0 auto 60px'
          }}>
            Every month Floors has different plant selections for you to decorate your surroundings!
          </p>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '40px',
            maxWidth: '800px',
            margin: '0 auto'
          }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{
                width: '80px',
                height: '80px',
                backgroundColor: '#90c695',
                borderRadius: '50%',
                margin: '0 auto 20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '32px'
              }}>
                <svg width={54} fill="#ffffff" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M5.859,8.341a5.876,5.876,0,0,0,5.283.117A9,9,0,0,0,11,10v2H6a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1H7v5a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V17h1a1,1,0,0,0,1-1V13a1,1,0,0,0-1-1H13V10a7.008,7.008,0,0,1,7-7,1,1,0,0,0,0-2,8.993,8.993,0,0,0-7.642,4.27C11.415,3.55,9.155,1,4,1A1,1,0,0,0,3,2C3,2.187,3.033,6.594,5.859,8.341ZM15,21H9V17h6Zm2-6H7V14H17ZM10.756,6.471c-1.635.677-2.924.736-3.841.172-1.154-.711-1.646-2.383-1.826-3.6C8.8,3.375,10.238,5.366,10.756,6.471Z"></path></g></svg>
              </div>
              <h3 style={{ marginBottom: '10px', color: '#333' }}>Sustainable processes</h3>
            </div>

            <div style={{ textAlign: 'center' }}>
              <div style={{
                width: '80px',
                height: '80px',
                backgroundColor: '#90c695',
                borderRadius: '50%',
                margin: '0 auto 20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '32px'
              }}>
                <svg width={54} fill="#ffffff" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M5,22H19a3,3,0,0,0,3-3V9a3,3,0,0,0-3-3H17V4a2,2,0,0,0-2-2H9A2,2,0,0,0,7,4V6H5A3,3,0,0,0,2,9V19A3,3,0,0,0,5,22ZM9,4h6V6H9ZM4,9A1,1,0,0,1,5,8H19a1,1,0,0,1,1,1v1.35l-8,3.556L4,10.35Zm0,3.539,7.594,3.375a1,1,0,0,0,.812,0L20,12.539V19a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1Z"></path></g></svg>
              </div>
              <h3 style={{ marginBottom: '10px', color: '#333' }}>Tailored service 24/7</h3>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer style={{
        backgroundColor: '#1a2332',
        color: 'white',
        padding: '60px 0 20px'
      }}>
        <div className="container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '40px',
            marginBottom: '40px'
          }}>
            <div>
              <h3 style={{ fontSize: '32px', marginBottom: '20px' }}>F</h3>
              <p style={{ marginBottom: '10px' }}>Floors GmbH</p>
              <p style={{ marginBottom: '10px' }}>Example street, 12 1st floor, Berlin</p>
              <p style={{ marginBottom: '10px' }}>Tel: +00 0000 0000</p>
              <p>Mo-Fr from 9:00 am to 7:00 pm</p>
            </div>

            <div>
              <h4 style={{ marginBottom: '20px' }}>About Floors</h4>
              <p style={{ marginBottom: '10px' }}>Blog</p>
              <p style={{ marginBottom: '10px' }}>Our story</p>
              <p>Career</p>
            </div>

            <div>
              <h4 style={{ marginBottom: '20px' }}>Legal</h4>
              <p style={{ marginBottom: '10px' }}>Contact</p>
              <p style={{ marginBottom: '10px' }}>Privacy</p>
              <p>Conditions</p>
            </div>
          </div>

          <div style={{
            borderTop: '1px solid #333',
            paddingTop: '20px',
            textAlign: 'center',
            color: '#666'
          }}>
            © 2025
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
